import { $t } from '@/i18n';
import { defineComponent, ref } from '@vue/composition-api';
import useJobService from '@composables/flow/useJobService';
import RelativeTime from '@/workbench/components/relative-time';
// 这个文件好像没有上线，没找到入口
const RelatedJobList = defineComponent({
    name: 'RelatedJobList',
    props: {
        // todo(ice): common route to fetch job list?
        projectId: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        jobQuery: {
            type: Object,
            default: {},
        },
    },
    setup(props) {
        const projectId = props.projectId || window.RUNTIME_CONFIGS.projectId;
        const { env: envId, branch: branchId } = window.RUNTIME_CONFIGS;
        const { relatedListForRuntime, countRelatedListForRuntime, allForRuntime, countAllForRuntime, } = useJobService({ projectId, envId, branchId });
        const jobList = ref([]);
        const pagination = ref({
            current: 1,
            pageSize: 10,
            total: 10,
        });
        const loading = ref(false);
        const fetchJobList = async (type, opt) => {
            loading.value = true;
            const resp = type === 'all'
                ? await allForRuntime(opt)
                : await relatedListForRuntime(type, opt);
            const total = type === 'all'
                ? await countAllForRuntime(opt.filter, opt.query)
                : await countRelatedListForRuntime(type, opt.filter, opt.query);
            if (opt.page)
                pagination.value.current = opt.page;
            pagination.value.total = total;
            jobList.value = resp;
            loading.value = false;
        };
        const onPageChange = (info) => {
            pagination.value.pageSize = info.pageSize;
            pagination.value.current = info.current;
            fetchJobList(props.type, { query: props.jobQuery, page: info.current, size: info.pageSize });
        };
        return {
            loading,
            pagination,
            projectId,
            envId,
            fetchJobList,
            onPageChange,
            jobList,
        };
    },
    watch: {
        type: {
            handler(val) {
                this.fetchJobList(val, { page: 1, query: this.jobQuery });
            },
            immediate: true,
        },
        jobQuery: {
            handler(val) {
                this.fetchJobList(this.type, { page: 1, query: val });
            },
            immediate: true,
            deep: true,
        },
    },
    render() {
        const columns = [
            {
                title: $t('k_dee6b505'),
                key: 'title',
                dataIndex: 'title',
            },
            {
                title: $t('k_4fd3370b'),
                key: 'status',
                dataIndex: 'status',
            },
            {
                title: $t('k_27231ac8'),
                key: 'message',
                dataIndex: 'message',
            },
            {
                title: $t('k_425d0c81'),
                key: 'currentApprovers',
                dataIndex: 'currentApprovers',
            },
            {
                title: $t('k_b6a559cf'),
                key: 'creator',
                dataIndex: 'creator',
            },
            {
                title: $t('k_ded521c7'),
                key: 'ctime',
                dataIndex: 'ctime',
                customRender: (text) => <RelativeTime time={text}/>,
            },
            {
                title: $t('k_4e2e12ab'),
                customRender: (txt, row) => <span>
            <router-link to={{ path: `/wuji/workflow/flow/${encodeURIComponent(row.flowId)}`, query: { jobId: row.id } }}>
              {$t('k_7aca5db4')}
            </router-link>
        </span>,
            },
        ];
        return <div>
      <a-table columns={columns} row-key="id" pagination={this.pagination} loading={this.loading} data-source={this.jobList} onChange={this.onPageChange}>
      </a-table>
    </div>;
    },
});
export default RelatedJobList;
